import type { RootState } from '../../../store'

export const selectIsLoggedIn = (state: RootState) => state.auth.isLoggedIn
export const selectAuthError = (state: RootState) => state.auth.error
